import { FC } from 'react';

interface iToolbar {}
const Toolbar: FC<iToolbar> = ({ children }) => {
  return <div className='toolbar'>{children}</div>;
};

export default Toolbar;
